<template>
<div v-if="ready" class="row table-color" style="margin: 0px; overflow-x: hidden; height: 100%">
 
    <div class="box-header col-sm-6" :style="'display:' + (title && title!='' ? 'initial;':'none;')">
        <h3 class="box-title">{{title}}</h3>
    </div>
    <form v-if="searchable.length > 0" class="form-inline d-flex justify-content-center md-form form-sm mt-0" style="height:25px;">
      <i :class="$root.icons.search_btn" style="font-size: 1.4em" aria-hidden="true" @click="showSearchField"></i>
      <input id="searchCatInput" v-if="searchFieldVisible" :placeholder="$Jed.firstUpperTranslate('search')+' '+$Jed.translate('name')+' '+$Jed.translate('index')" type="search" 
        style="height:25px; border-color: #d2d6de; border-top: none; border-left: none; border-right: none;" 
        class="form-control form-control-sm ml-3 w-75" aria-controls="example1" v-model="filter">
    </form>
    <!-- /.box-header -->
    <div class="box-body" :style="{padding: removeDecorations ? '0px' : 'initial'}">
      <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
          <div class="row">
              <div class="col-sm-6">
                  <div id="example1_length" class="dataTables_length"></div>
              </div>
          </div>

          <div class="row" style="margin: 0px;">
          <div class="col-sm-12 table-responsive" style="padding: 0px">
              <table :aria-describedby="configs.ID" role="grid" :id="configs.ID" class="table dataTable display"
              :style="{margin: removeDecorations ? '0px !important' : 'initial'}">

              <thead style="display: block;"> <!--style="display: block;"-->
                  <tr role="row">
                  <th :key="h.name" v-if="h.visible" v-for="h in header" :style="'width:'+ h.width +'%'" :class="{'sorting': h.sorting}" aria-controls="example1" rowspan="1"
                  @click="checkAndSort(h)" >{{h.name}}</th>
                  </tr>
              </thead>

              <tbody style="display: block; height: 160px; overflow-y: auto;"> 
                  <tr :key="index" v-for="(iter, index) in iterable" class="even" role="row" :id="iter.id"
                  :class="{'active': isHighlighted(iter)}" 
                   style="cursor: pointer;"
                  @click="activate(iter)">
                      <td :key="h.name" v-if="h.visible" v-for="h in header" :style="'text-align: ' + (h.align ? h.align: 'initial') + ';'"
                      @click="h.onCellClick != null ? h.onCellClick(iter) : null">
                        <span v-if="!h.is_only_icon" v-html="iter[h.prop]"></span>
                        <i v-else :class="h.icon_class" style="margin: 0px;"></i>
                      </td>
                  </tr>
              </tbody>

              </table>
          </div>
          <div v-if="!iterable || iterable.length == 0" class="col-sm-12">
              <div class="list-group-item table-color">{{nothing_found}}</div>
          </div>
          </div>
      </div>
    <!-- /.box-body -->
    </div>

</div>
</template>

<script>

import deepExtend from "deep-extend";

export default {
  props: {
    name: String,
    array: {
      type: Array,
      default: function() {
        return [];
      }
    },
    //la funzione di highlight passa da focus e configs.highlighted_parameter
    //se highlighted parameter esiste, lo si confronta con focus, altrimenti focus viene confrontato con l'intero oggetto dell'iterazione (iter)
    //focus deve sempre essere passato come proprietà, e deve essere comparabile opportunamente
    focus: String,
    removeDecorations: {
      type: Boolean,
      default: false
    },
    // funzione da eseguire all'onclick della riga, di default: evidenzia la selezione
    rowClicked: {
      type: Function,
      default(option) {
        console.log(option);
      }
    },
    // il nome del'oggetto colonna (def - "prima" e "seconda"), deve coincidere con il nome della proprietà dell'array da visualizzare
    configs: {
      type: Object
    },
    //Stringa da mostrare quando la ricerca non restituisce risultati
    nothing_found: {
      type: String,
      default: "Nessun dato da mostrare"
    }
  },
  mounted: function() {
    
    //merge delle colonne impostate nel componente chiamante e quelle richieste da config
    deepExtend(this.configs.columns, this.$Components[this.name].columns)

    this.$nextTick(() => {
      this.merged_c = this.configs;
      if (this.merged_c.title) {
        this.title = this.$Jed.firstUpperTranslate(this.merged_c.title);
      }

      for (var prop in this.merged_c.columns) {
        var obj = this.merged_c.columns[prop];

        obj.name =
          obj.name != false ? this.$Jed.firstUpperTranslate(obj.name) : "";
        obj.prop = prop;
        this.header.push(obj);
      }

      this.header.sort(function(a, b) {
        return a.position - b.position;
      });
      this.iterable = this.array.slice();

      var needVisible = !this.$Behaviors.searchCatalogByNotes

      for (var i = 0; i < this.header.length; i++) {
        if(needVisible){
          if (this.header[i].visible && this.header[i].searchable) {
            this.searchable.push({
              name: this.header[i].name,
              prop: this.header[i].prop
            });
          }
        }else{
          if (this.header[i].searchable) {
            this.searchable.push({
              name: this.header[i].name,
              prop: this.header[i].prop
            });
          }
        }
        
      }
      // END FETCHING FROM CONFIGS
      this.ready = true;

      //ricalcolo dimensione colonne tabella selezione catalogo (mettendo l'header fisso c'era il problema delle colonne schiacciate)
      this.$nextTick(() => {
        var $table = $('#catalogsTable'),
            $bodyCells = $table.find('tbody tr:first').children(),
            $headCells = $table.find('thead tr:first').children(),
            colWidth = null,
            colWidthH = null;
        /* console.log($table.find('tbody').width())
        console.log($table.find('thead').width()) */

        // recupero la larghezza delle colonne del tbody
        colWidth = $bodyCells.map(function() {
            return $(this).width();
        }).get();

        //console.log(colWidth) 

        // recupero la larghezza delle colonne del thead
        colWidthH = $headCells.map(function() {
            return $(this).width();
        }).get();

        //console.log(colWidthH)

        /* //somma delle larghezze delle colonne del tbody 
        var colWidthTotal = 0
        $bodyCells.each(function() {
            colWidthTotal += $(this).width();
        })*/
        //console.log(colWidthTotal) 

        //somma delle larghezze delle colonne del thead
        var colWidthTotalH = 0
        $headCells.each(function() {
            colWidthTotalH += $(this).width();
        })
        //console.log(colWidthTotalH)
        
        // imposta la larghezza delle colonne del thead e del body uguali così corrispondono
        $table.find('thead tr').children().each(function(i, v) {
            $(v).width((colWidthH[i]*$table.find('thead').width())/colWidthTotalH);
        }); 
        $table.find('tbody tr').children().each(function(i, v) {
            $(v).width((colWidthH[i]*$table.find('thead').width())/colWidthTotalH);
        });
      })

      this.$nextTick(() => {
        this.$emit('dynTableReady')
      })
    });
  },
  data: function() {
    return {
      title: "",
      iterable: [],
      header: [],
      ready: false,
      sortingBy: "",
      desc: false,
      filter: "",

      //proprietà per cui è possibile filtrare
      searchable: [],
      searchFieldVisible: false
    };
  },
  watch: {
    array: function() {
      this.iterable = this.array;
    },
    filter: function() {
      this.filterTableRows();
    }
  },
  methods: {
    showSearchField: function(){
      this.searchFieldVisible = !this.searchFieldVisible
      this.$nextTick(() => {
        if(document.getElementById("searchCatInput"))document.getElementById("searchCatInput").focus();
      })
    },
    isHighlighted: function(obj) {
      if (!this.focus) {
        return false;
      }
      var has_highlighting_parameter =
        this.configs.highlighting_parameter != null;
      return has_highlighting_parameter
        ? obj[this.configs.highlighting_parameter] == this.focus
        : obj == this.focus;
    },
    activate: function(option) {
      this.rowClicked(option);
    },
    checkAndSort: function(h) {
      if (h.sorting) {
        this.sortBy(h.prop);
      }
    },
    sortBy: function(param) {
      if (this.sortingBy == param) {
        this.desc = !this.desc;
      } else {
        this.desc = false;
      }
      this.sortingBy = param;

      var sort_function;
      if (this.iterable.length > 0) {
        if (isNaN(this.iterable[0][param])) {
          if (!this.desc) {
            sort_function = function(a, b) {
              return a[param] < b[param] ? -1 : 1;
            };
          } else {
            sort_function = function(a, b) {
              return a[param] > b[param] ? -1 : 1;
            };
          }
        } else {
          if (!this.desc) {
            sort_function = function(a, b) {
              return a[param] - b[param];
            };
          } else {
            sort_function = function(a, b) {
              return b[param] - a[param];
            };
          }
        }
      }
      var vm = this;
      this.iterable.sort(function(a, b) {
        // i valori vuoti o null, li ordino con priorità adeguata
        if (a[param] == "" || a[param] == null) {
          return vm.desc ? 1 : -1;
        }
        if (b[param] == "" || b[param] == null) {
          return vm.desc ? -1 : 1;
        }
        return sort_function(a, b);
      });
    },
    filterTableRows: function() {
      var $table = $('#catalogsTable'),
          $headCells = $table.find('thead tr:first').children(),
          colWidthH = null;

      // recupero la larghezza delle colonne del thead
      colWidthH = $headCells.map(function() {
          return $(this).width();
      }).get();

      //somma delle larghezze delle colonne del thead
      var colWidthTotalH = 0
      $headCells.each(function() {
          colWidthTotalH += $(this).width();
      })
        
      if (this.filter == null || this.filter.trim() == "") {
        this.iterable = this.array.slice();
        // reimposta la larghezza delle colonne del body uguali a quelle del thead così corrispondono
        this.$nextTick(()=>{
          $table.find('tbody tr').children().each(function(i, v) {
            $(v).width((colWidthH[i]*$table.find('thead').width())/colWidthTotalH);
          });
        })
      } else {
        var vm = this; //rendo l'istanza di vue js visibile all'interno della funzione anonima
        var f = this.filter.toLowerCase();

        this.iterable = this.array.filter(function(row) {
          for (var i = 0; i < vm.searchable.length; i++) {
            var obj = vm.searchable[i];
            try {
              if (
                row[obj.prop]
                  .toString()
                  .toLowerCase()
                  .includes(f)
              ) {
                return true;
              }
            } catch (err) {
              console.log(err);
            }
          }
          return false;
        });
        // reimposta la larghezza delle colonne del body uguali a quelle del thead così corrispondono
        this.$nextTick(()=>{
          $table.find('tbody tr').children().each(function(i, v) {
            $(v).width((colWidthH[i]*$table.find('thead').width())/colWidthTotalH);
          });
        })
      }
    }
  }
};
</script>

<style>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url("/static/css/jquery.dataTables.min.css");*/
@import url("/static/js/plugins/datatables/jquery.dataTables.min.css");

/*@import url("/static/js/plugins/datatables/dataTables.bootstrap.css");

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: "FontAwesome";
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}*/
</style>
<style scoped>

.form-control:focus{
  border-bottom: 1px solid #3c8dbc !important;
  box-shadow: 0 1px 0 0 #93d7ff;
}
.list-group-item {
  padding: 5px 15px;
  text-align: center;
}

td,
th {
  padding: 8px 2px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/dynamic/DynTable.vue?07ef5d34